var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Typography, useTheme } from '@mui/material';
import { Fade, ScoreGraph, SideImageLayout, useSimpleModal } from 'hx-ui';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { HearingAbilityContent } from '@/components/hearing-ability-content.component';
import { pageImages } from '@/pages/images';
import { StyledProgress } from '@/components/styled-progress.component';
import { useSetProgress } from 'hx-progress';
import { BsInfoCircle } from 'react-icons/bs';
import { Footer } from '@/components/footer.component';
import { isResultsCategory } from '@/components/results-category/helpers/is-results-category.helper';
import { categoryPathMap } from '@/components/results-category/constants/category-path-map.constant';
import { ErrorMessage } from '@/components/error-message.component';
import { EndSessionLink } from '@/components/end-session-link.component';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
import { NavigationButton } from '@/components/navigation-button.component';
export function ScoreGraphPage() {
    var theme = useTheme();
    var score = useSelector(function (state) { return state.dinTest.result.score; });
    var navigate = useNavigate();
    var category = useSelector(function (state) { return state.dinTest.result.category; });
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    var path = isResultsCategory(category)
        ? categoryPathMap[category]
        : category;
    var _a = useSimpleModal(_jsx(HearingAbilityContent, {}), {
        modalProps: {
            className: 'max-w-[580px]',
        },
    }), modal = _a[0], toggleModal = _a[1];
    useSetProgress(2, 3);
    function handleNext() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handleSendButtonClick('test_result')];
                    case 1:
                        _a.sent();
                        navigate("/result-category/".concat(path));
                        return [2 /*return*/];
                }
            });
        });
    }
    if (score === undefined)
        return (_jsx(ErrorMessage, { action: function () { return navigate('/'); }, actionText: "Retry", message: "Oops! No results found" }));
    return (_jsx(SideImageLayout, { imageLeft: pageImages.earCloseUp, leftPanelWidth: '40%', header: _jsxs(Fade, __assign({ className: "grid py-4 place-content-center" }, { children: [_jsx(StyledProgress, { textClassName: 'font-bold capitalize' }), _jsx(Typography, __assign({ variant: "h2", className: 'mt-3' }, { children: "Your hearing assessment results:" }))] })), content: _jsxs(Fade, __assign({ delay: 0.1, className: "p-4" }, { children: [_jsx(ScoreGraph, { color: "linear-gradient(180deg, ".concat(theme.palette.custom.normalCategory.main, " 0%, ").concat(theme.palette.custom.mildCategory.main, " 50%, ").concat(theme.palette.custom.moderateCategory.main, ") 100%"), score: score || 0, labelProps: {
                        className: 'font-bold',
                    }, needleProps: {
                        labelStyles: {
                            backgroundColor: theme.palette.primary.main,
                        },
                        adornment: (_jsx(IconButton, __assign({ "aria-label": "info", style: {
                                translate: '0 -10px',
                            }, onClick: function () { return toggleModal(); } }, { children: _jsx(BsInfoCircle, { size: "23px", color: theme.palette.primary.main }) }))),
                    }, markers: [
                        {
                            value: 85,
                            text: 'Your Hearing is OK',
                        },
                        {
                            value: 73.5,
                            marker: true,
                        },
                        {
                            value: 50,
                            text: 'Some Difficulty Hearing',
                        },
                        {
                            value: 27.5,
                            marker: true,
                        },
                        {
                            value: 15,
                            text: 'Significant Hearing Difficulties',
                        },
                    ], markerProps: {
                        color: theme.palette.primary.main,
                    } }), modal] })), nav: _jsxs("div", __assign({ className: 'flex flex-col gap-4 mx-auto w-[85%] sm:w-fit py-4' }, { children: [_jsx(NavigationButton, { onClick: handleNext, label: "Next", variant: "contained" }), _jsx(EndSessionLink, {})] })), footer: _jsx(Footer, {}) }));
}
export default ScoreGraphPage;
